import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/client';
import type { components } from '@/api/schema';
import { farmScopeQuery, useFarmScope } from '@/stores/farmScope';

/**
 * The one request the whole dashboard reads.
 *
 * Every figure comes from a single call, so the cards can never disagree with
 * each other, and a dashboard with seven of them is still one round trip.
 * Refreshed on the same minute as "Action needed".
 */

export type Overview = components['schemas']['DashboardOverviewDto'];

export const REFRESH_MS = 60_000;

export function useOverview() {
  const farmIds = useFarmScope((s) => s.selectedFarmIds);

  const query = useQuery({
    queryKey: ['dashboard', 'overview', farmIds],
    queryFn: () =>
      api.get('/api/v1/dashboard/overview', farmScopeQuery(farmIds)) as Promise<Overview>,
    refetchInterval: REFRESH_MS,
  });

  return { ...query, farmIds };
}
